import defaultClassicSound from "../assets/sound.mp3";

const formatSoundName = (filename) => {
  return filename
    .replace(/\.(mp3|ogg|wav)$/i, "")
    .replace(/\s*-\s*QuickSounds\.com/gi, "")
    .replace(/[_-]+/g, " ")
    .trim();
};

const getPublicSoundUrl = (filename) => {
  const publicUrl = process.env.PUBLIC_URL || "";
  const cleanBase = publicUrl.replace(/\/$/, "");
  return `${cleanBase}/sound/${encodeURIComponent(filename)}`;
};

// Os sons personalizados são publicados diretamente em public/sound. Não use
// require.context aqui: a pasta correspondente em src/assets não existe e o
// Webpack emite um aviso em toda compilação.
const PUBLIC_SOUND_FILES = [
  "Android Notifications - Pixie Dust - QuickSounds.com.mp3",
  "espn notification - QuickSounds.com.mp3",
  "Grindr Notification sound HQ - QuickSounds.com.mp3",
  "instagram thud - QuickSounds.com.mp3",
  "Metal Gear Solid Alert - QuickSounds.com.mp3",
  "Motorola Notification - QuickSounds.com.mp3",
  "OLHA A MENSAGEM a - QuickSounds.com.mp3",
  "Olha a Mensagem Clássico - QuickSounds.com.mp3",
  "Samsung notification sound - QuickSounds.com.mp3",
  "samsung whistle notification sound - QuickSounds.com.mp3",
  "Spongebob Disappointed - QuickSounds.com.mp3",
  "Telegram notification - QuickSounds.com.mp3",
  "TF2 Notification Sound - QuickSounds.com.mp3",
  "Western Music - QuickSounds.com.mp3",
  "WhatsApp Sound - QuickSounds.com.mp3",
  "Whatsapp Web Notification - QuickSounds.com.mp3",
  "Whatsapp Whistle Notification - QuickSounds.com.mp3",
  "Windows XP Shutdown - QuickSounds.com.mp3",
  "xbox series notification - QuickSounds.com.mp3",
];

const loadSoundsFromContext = () => {
  const sounds = [
    {
      id: "default",
      filename: "sound.mp3",
      name: "Padrão Clássico (Sistema)",
      url: defaultClassicSound,
      isDefault: true,
    },
  ];

  PUBLIC_SOUND_FILES.forEach((filename) => {
    sounds.push({
      id: filename,
      filename,
      name: formatSoundName(filename),
      url: getPublicSoundUrl(filename),
      isDefault: false,
    });
  });

  return sounds;
};

export const AVAILABLE_SOUNDS = loadSoundsFromContext();

export const getAvailableSounds = () => {
  return AVAILABLE_SOUNDS;
};

export const getSoundInfo = (soundId) => {
  if (!soundId || soundId === "default") {
    return AVAILABLE_SOUNDS[0] || { id: "default", url: defaultClassicSound, name: "Padrão Clássico (Sistema)" };
  }
  const found = AVAILABLE_SOUNDS.find((s) => s.id === soundId || s.filename === soundId);
  return found || AVAILABLE_SOUNDS[0] || { id: "default", url: defaultClassicSound, name: "Padrão Clássico (Sistema)" };
};

export const getSoundUrl = (soundId) => {
  return getSoundInfo(soundId).url || defaultClassicSound;
};

export const getCompanySoundId = () => {
  try {
    const directSound = localStorage.getItem("companySoundAlert");
    if (directSound && directSound !== "default") {
      return directSound;
    }
    const stored = localStorage.getItem("headerConfig");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed?.alertSound) {
        return parsed.alertSound;
      }
    }
  } catch (_) {}
  return "default";
};

export const playCompanyAlertSound = (volume, contactSoundId) => {
  try {
    const soundId = contactSoundId || getCompanySoundId();
    const soundUrl = getSoundUrl(soundId);
    const audio = new Audio(soundUrl);
    const vol = typeof volume === "number" ? Math.max(0, Math.min(1, volume)) : 1;
    audio.volume = vol;
    audio.currentTime = 0;
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
    return audio;
  } catch (err) {
    console.error("Erro ao reproduzir som de notificação da empresa:", err);
    return null;
  }
};
